import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { parseDecimal } from '../../../../../libs/utils'
import { OtherPaymentForm } from './types'
import { initialOtherModalState } from './const'

const buildBody = (data: OtherPaymentForm) => {
  const wallet = String(data.walletId ?? data.wallet ?? '')
  return {
    wallet,
    walletId: wallet,
    toWallet: data.toWallet,
    product: data.product,
    sentAmount: parseDecimal(data.sentAmount),
    sentCurrency: data.sentCurrency,
    receivedAmount: parseDecimal(data.receivedAmount),
    receivedCurrency: data.receivedCurrency,
    sentCommission: parseDecimal(data.sentCommission),
    sentCommissionCurrency: data.sentCommissionCurrency,
    receivedCommission: parseDecimal(data.receivedCommission),
    receivedCommissionCurrency: data.receivedCommissionCurrency,
    sentExchangeRate: parseDecimal(data.sentExchangeRate),
    receivedExchangeRate: parseDecimal(data.receivedExchangeRate),
    psCommission: parseDecimal(data.psCommission),
    inProgress: data.inProgress,
    comment: data.comment,
    dateTime: data.dateTime,
  }
}

export const addOtherPaymentMounted = createEvent<OtherPaymentForm>()
export const editOtherPaymentMounted = createEvent<OtherPaymentForm>()
export const deleteOtherPaymentMounted = createEvent<{ id: string }>()
export const getOtherPaymentByIdMounted = createEvent<{ id: string }>()
export const setOtherPaymentForm = createEvent<OtherPaymentForm>()

export const $otherPaymentForm = restore(
  setOtherPaymentForm,
  initialOtherModalState,
)

export const addOtherPayment = fx<ReturnType<typeof buildBody>, void>({
  method: 'POST',
  url: `/finance/other_payment`,
})

export const editOtherPayment = fx<ReturnType<typeof buildBody>, void>({
  method: 'PUT',
  url: `/finance/other_payment/{id}`,
})

export const getOtherPaymentById = fx<{ id: string }, OtherPaymentForm>({
  method: 'GET',
  url: `/finance/other_payment/{id}`,
})

export const deleteOtherPayment = fx<OtherPaymentForm, void>({
  method: 'DELETE',
  url: `/finance/other_payment/{id}`,
})

sample({
  clock: addOtherPaymentMounted,
  fn: (data) => ({ body: buildBody(data) }),
  target: addOtherPayment,
})

sample({
  clock: editOtherPaymentMounted,
  fn: (data) => ({
    url: `/finance/other_payment/${data.id}`,
    body: buildBody(data),
  }),
  target: editOtherPayment,
})

sample({
  clock: deleteOtherPaymentMounted,
  fn: ({ id }) => ({ url: `/finance/other_payment/${id}` }),
  target: deleteOtherPayment,
})

sample({
  clock: getOtherPaymentByIdMounted,
  fn: ({ id }) => ({ url: `/finance/other_payment/${id}` }),
  target: getOtherPaymentById,
})

sample({
  clock: getOtherPaymentById.doneData,
  fn: (doneData) => doneData.body,
  target: setOtherPaymentForm,
})
